module.exports = __webpack_public_path__ + "static/media/delete.10ac5302.svg";


//////////////////
// WEBPACK FOOTER
// ./src/iconic/delete.svg
// module id = 1408
// module chunks = 0